import { render, staticRenderFns } from "./RelationstypModal.vue?vue&type=template&id=26a279e6"
import script from "./RelationstypModal.vue?vue&type=script&lang=js"
export * from "./RelationstypModal.vue?vue&type=script&lang=js"
import style0 from "./RelationstypModal.vue?vue&type=style&index=0&id=26a279e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports